import "./header.scss";

// Badge display rules (spec):
//   0    → hidden (render nothing, keeps the Header layout compact)
//   1–99 → exact number
//  100+  → "99+" (small badge that never breaks the Header layout)
// Latin digits keep the tiny badge legible inside the Vazir mobile shell.
export function formatNotificationBadgeCount(count) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  if (n > 99) {
    return "99+";
  }
  return String(Math.floor(n));
}

function NotificationBadge({ count }) {
  const display = formatNotificationBadgeCount(count);
  if (display === null) {
    return null;
  }
  return (
    <span
      className="HeaderNotification-badge"
      data-testid="header-notification-badge"
      data-count={Number(count)}
      aria-hidden="true"
    >
      {display}
    </span>
  );
}

export default NotificationBadge;
